import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"bv-truncate\" ...attributes>\n  {{yield}}\n</div>")